export const fixReCaptchaChallengePosition = () => {
  const reCaptchaIframe = document.getElementsByTagName("iframe");
  const arrayReCaptchaIframes = Array.from(reCaptchaIframe);
  arrayReCaptchaIframes.forEach((r) => {
    if (r.style.width === "100%" && r.style.height === "100%") {
      r.style.position = "fixed";
      r.style.top = "0";
      r.style.bottom = "0";
      r.style.margin = "auto";
    }
  });
};
